import { AssetConfigContextValue } from "./types";

export const initialAssetsConfigContextValue: AssetConfigContextValue = {
  loading: true,
  error: null,
  config: {} as any,
  tableColumns: [],
};
